import React from 'react';
import Reflux from 'reflux';
import {Button, InputNumber} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice} from 'Utils';
import {objectSerial, config} from 'Utils';

import {getShoppingCarList, deleteShoppingCarList, addFavoritesList, changeNum} from '../../service/shoppingCar';
/*获取购物车列表,删除,加入收藏夹接口*/
import {proBigNameScreening} from '../../service/product';
import {Store, Actions} from './store';

class ShoppingCarList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.userData = JSON.parse(window.localStorage.getItem('login_user_information') || '{}');
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.state = {
            opts: ['购物车'],
            key: 0,
            selectedRowKeys: [],
            proBigName_type: [],
            rows: [],
            total: 1,
            searchObj: {
                userId: this.userData.id,
                name: '',
                category: [],
                active: '',
                s: 10,
                p: 1,
                channelCode: this.channelData.split('|')[1] || ''
            },
            categoryData: [],
            item: [],
            productId: '',
            loading: true,
        };
        this.orderChange = this.orderChange.bind(this);
        this.removeChange = this.removeChange.bind(this);
        this.addfFavorites = this.addfFavorites.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.exportChange = this.exportChange.bind(this);
    };

    /*选择列表*/
    onSelectChange = (selectedRowKeys, item) => {

        var selectitems = this.state.item;

        var items = [];

        item.forEach((key, i) => {

            var flag = true;

            selectitems.forEach((k, z) => {
                if (k.id == item[i].id) {
                    flag = false;
                    return;
                }
            })
            if (flag) {
                selectitems.push(item[i]);
            }
        });

        selectitems.forEach((key, i) => {
            if (selectedRowKeys.indexOf(key.id) >= 0) {
                items.push(selectitems[i]);
            }
        });

        this.setState({selectedRowKeys, item: items});
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*数量加减*/
    changeNumber = (record, index, value) => {
        var self = this;
        // console.log(record);
        // console.log(index);
        // console.log( value);
        // var value1= value;
        // if (record.minPackageQuantity > 1) {
        //     var minPackageQuantity = record.minPackageQuantity;
        //     value1 = (parseInt(value1/minPackageQuantity) + 1) * minPackageQuantity;
        //     if (value1<minPackageQuantity) {
        //         value1 = minPackageQuantity;
        //     }
        //     var rows = [...self.state.rows];
        //     rows[index].count = value1;
        //     self.setState({rows:rows});
        // }
        changeNum({id: record.id, count: value}).then(result => {
            console.log(result);

        })
    };

    /*生成订单*/
    orderChange() {
        const {item} = this.state;
        for (let i = 0; i < this.state.selectedRowKeys.length; i++) {
            if (item[i].minPackageFlag === 'Y' && (item[i].count % item[i].minPackageQuantity)) {
                openNotice('warning', '购买数量必须是最小起订量的整数倍!');
                return;
            }
        }
        if (this.state.selectedRowKeys <= 0) {
            openNotice('warning', '购物车创建订单，请勾选产品    (如果没产品，请按以下操作： 订单管理→采购订单→新增常规订单（项目订单）)');
            return;
        }
        window.sessionStorage.setItem('list_orders', JSON.stringify(item));
        this.goView('/shoppingCar/add/4');
    };

    /*导出*/
    exportChange() {
        let _searchObj = {...this.state.searchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        _searchObj.s = 99999;
        let url = `${config.server}/api/v1/dms/shoppingCart/exportExcel?${objectSerial(_searchObj)}`;
        window.open(url);
    };

    /*删除*/
    removeChange() {
        if (this.state.selectedRowKeys.length === 0) {
            console.log(this.state.selectedRowKeys)
            openNotice('warning', '请选择要删除的产品');
            return;
        }
        let params = {
            'ids': this.state.selectedRowKeys
        };
        let self = this;
        deleteShoppingCarList(params).then(function (result) {
            if (result && result.code == 200) {
                openNotice('success', '删除成功', '');
                self.setState({selectedRowKeys: []});
                self.initData();
            } else {
                openNotice('error', '删除失败', (result && result.message) ? result.message : '');
            }
        });
    };

    removeChange1(id) {
        var ids = [];
        ids.push(id);
        let params = {
            'ids': ids
        };
        let self = this;
        deleteShoppingCarList(params).then(function (result) {
            if (result && result.code == 200) {
                openNotice('success', '删除成功', '');
                self.setState({selectedRowKeys: []});
                self.initData();
            } else {
                openNotice('error', '删除失败', (result && result.message) ? result.message : '');
            }
        });
    };

    /*加入收藏夹*/
    addfFavorites(item) {
        // console.log(item);
        if (this.state.selectedRowKeys.length === 0) {
            openNotice('warning', '请选择要加入收藏夹的产品');
            return;
        }
        for (let i = 0; i < this.state.selectedRowKeys.length; i++) {
            if (item[i].minPackageFlag === 'Y' && (item[i].count % item[i].minPackageQuantity)) {
                openNotice('warning', '购买数量必须是最小起订量的整数倍!');
                return;
            }
        }
        var _arr = [];
        item.forEach(ele => {
            _arr.push({productId: ele.productId});
        });
        // console.log(_arr)
        let self = this;
        addFavoritesList(_arr).then(function (result) {
            if (result && result.code == 200) {
                openNotice('success', '加入收藏夹成功', '');
                self.initData();
            } else {
                openNotice('error', '加入收藏夹失败', (result && result.message) ? result.message : '');
            }
        });
    }

    /*筛选*/
    setFilterParam(name, value) {
        this.setState({searchObj: {...this.state.searchObj, [name]: value}})
    };

    /*筛选重置*/
    advanceReset() {
        let self = this;
        self.setState({
            searchObj: {
                ...this.state.searchObj,
                name: '',
                category: [],
                active: '',
                proLine: '',
                proBigName: '',
                productCode: '',
                stockType: '',
            }
        }, function () {
            self.initData();
        });
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        let self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }
        }, function () {
            self.initData();
        });
    };

    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.initData();
        });
    }

    /*获取列表数据*/
    initData() {
        let self = this;
        self.setState({loading: true});
        let searchObj = self.state.searchObj;
        getShoppingCarList(searchObj).then(function (result) {
            if (result && result.code == 200) {
                self.setState({
                    'rows': result.data.productList || [],
                    'total': result.data.count,
                    'loading': false,
                });
            } else {
                openNotice('error', '数据获取失败', '');
            }
        });
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'shoppingCar') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
            Actions.paramChange({});
        }
    };

    componentWillMount() {
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...this.state.searchObj,
                    ...data.params
                }
            });
        }
        proBigNameScreening().then(res => { //物料大类
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.name
                    })
                });
                this.setState({proBigName_type: arr},
                )
            }
        });
    };

    componentDidMount() {
        this.initData();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook, this.state.item);
    };

    render() {
        const {opts, key, rows, total, searchObj, selectedRowKeys, proBigName_type, loading} = this.state;
        const advanceProps = {
            fileds: [
                {
                    name: 'name',
                    label: '物料名称',
                    text: '输入物料名称',
                    type: 'default',
                    defaultValue: searchObj.name
                },
                {
                    name: 'proLine',
                    label: '产品线',
                    text: '选择状态',
                    options: [
                        {value: '', text: '全部'},
                        {value: '01', text: '元器件'},
                        {value: '02', text: '电工'},
                        {value: '03', text: '电表'},
                        {value: '04', text: '变频器'},
                        {value: '05', text: '天e'},
                        {value: '06', text: 'TG精品'},
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.proLine || ''
                },
                {
                    name: 'proBigName',
                    label: '物料大类',
                    text: '选择物料大类',
                    options: proBigName_type,
                    multiple: false,
                    type: 'select',
                    showSearch: true,
                    defaultValue: searchObj.proBigName || []
                },
                {
                    name: 'productCode',
                    label: '物料编码',
                    text: '输入物料编码',
                    type: 'default',
                    defaultValue: searchObj.productCode
                },
                {
                    name: 'stockType',
                    label: '库存类型',
                    text: '选择库存类型',
                    options: [
                        {value: '', text: '全部'},
                        {value: '库存', text: '库存'},
                        {value: '非库存', text: '非库存'},
                        {value: '定制', text: '定制'},
                        {value: '专属定制', text: '专属定制'},
                        {value: '退市', text: '退市'},
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.stockType || ''
                },
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '物料名称',
                    dataIndex: 'name',
                    render: (text, record, index) => {
                        if (record.orderManagerFlag == '' || record.orderManagerFlag == null) {
                            return (<span>{text}</span>)
                        } else if (record.itemManagerFlag == '' || record.itemManagerFlag == null) {
                            return (<span>{text}</span>)
                        } else {
                            return <a href={`#/product/${record.productId}`}>{text}</a>
                        }
                    }
                }, {
                    title: '物料大类',
                    dataIndex: 'proBigName',
                }, {
                    title: '物料编码',
                    dataIndex: 'productCode'
                },
                {
                    title: '单位',
                    dataIndex: 'unit'
                },
                {
                    title: '库存类型',
                    dataIndex: 'stockType'
                },
                {
                    title: '最小装箱数',
                    dataIndex: 'minOrderQuantity'
                },
                {
                    title: '内盒凑整数',
                    dataIndex: 'minPackageQuantity'
                },
                {
                    title: '装箱数',
                    dataIndex: 'packageQuantity'
                },
                {
                    title: '产品线',
                    dataIndex: 'proLine'
                },
                {
                    title: '牌价',
                    dataIndex: 'price'
                },
                {
                    title: '数量',
                    dataIndex: 'count',
                    render: (text, record, index) => {
                        return <InputNumber min={1} max={999999} defaultValue={record.count}
                                            onChange={this.changeNumber.bind(this, record, index)}
                                            step={record.minPackageFlag === 'Y' && record.minPackageQuantity ? record.minPackageQuantity : 1}/>
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'a',
                    render: (text, record, index) => {
                        return <Button style={{background: '#red'}}
                                       onClick={this.removeChange1.bind(this, record.id)}>移除</Button>
                    }
                }
            ],
            rows,
            rowSelection: {
                selectedRowKeys,
                onChange: this.onSelectChange,
                getCheckboxProps: record => ({
                    disabled: (record.itemManagerFlag == null || record.orderManagerFlag == null)
                })
            }
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}></DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps}/>
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <Button style={{left: 0, background: '#f2302f', color: '#fff'}}
                            onClick={this.orderChange}>生成订单（{this.state.selectedRowKeys.length}）</Button>
                    <Button style={{left: 8}} onClick={this.removeChange}>删除</Button>
                    <Button style={{left: 16}}
                            onClick={this.addfFavorites.bind(this, this.state.item)}>加入收藏夹</Button>
                    <Button style={{position: 'absolute', bottom: 8, right: 0}} icon="export"
                            onClick={this.exportChange}>导出</Button>
                </div>
                <TableView {...tableViewProps}/>
            </div>
        </div>
    }
}
;
export default withRouter(ShoppingCarList);



// WEBPACK FOOTER //
// ./src/routes/shoppingCar/list.js